import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { selector } from "../../store/reducers/currentRide";
import { RideType } from "../../constants/rideTypes";
import RideService from "../../services/ride";
import RideCard from "./RideCard";
import styles from "./style.module.css";

export default React.memo((props => {
  const [ expanded, setExpanded ] = React.useState(false);
  const lastRideId = useSelector((state) => selector(state)?.lastRideId);

  const { isFetching, data, refetch } = useQuery([ false, 1, 100 ], RideService.getRides, {
    queryFnParamsFilter: args => args.slice(1),
    refetchInterval: 30 * 1000,
    refetchOnWindowFocus: true,
  });

  const upcomingRides = data?.rides?.filter?.(x => ![ RideType.CANCELED, RideType.COMPLETED, RideType.NO_SHOW ].includes(x.status)) || [];

  React.useEffect(() => {
    if (lastRideId) {
      refetch();
      setExpanded(true);
    }
  }, [ lastRideId ]);


  if (!upcomingRides.length || (!upcomingRides.length && isFetching)) {
    return null;
  }

  return (
    <Accordion
      className={styles.container}
      expanded={expanded}
      onChange={(e, exp) => setExpanded(exp)}
    >
      <AccordionSummary
        className={styles.headerContainer}
        expandIcon={<ExpandMoreIcon />}
      >
        <span className={styles.header}>Upcoming rides:</span>
        <span className={styles.ridesCount}>{upcomingRides.length}</span>
      </AccordionSummary>
      <AccordionDetails className={styles.details}>
        {upcomingRides.map(ride =>
          <RideCard
            key={ride.id}
            refetchList={refetch}
            ride={ride}
          />,
        )
        }
      </AccordionDetails>
    </Accordion>
  );
}));
